<template>
    <VerticalSlideTransition :show="show">
        <!-- Needed to take up the space of the annoucnement since it is fixed, this make all following components adapt to the presence of the announcement -->
        <div class="w-full h-[--announcement-height]"></div>
        <Transition name="fade">
            <div
                v-if="show"
                class="fixed top-0 h-[--announcement-height] w-full flex justify-between z-announcement bg-primary text-primary-text px-6 sm:px-3.5 drop-shadow-lg"
            >
                <div class="flex items-center text-sm">
                    <p
                        class="font-semibold"
                        v-text="$page.props.announcement?.banner_bold"
                    />
                    <div
                        class="px-1"
                        v-if="
                            $page.props.announcement?.banner_bold &&
                            $page.props.announcement?.banner_text
                        "
                    >
                        <svg
                            viewBox="0 0 2 2"
                            class="mx-1 inline size-1 fill-current"
                            aria-hidden="true"
                        >
                            <circle cx="1" cy="1" r="1" />
                        </svg>
                    </div>
                    <p v-text="$page.props.announcement?.banner_text" />
                    <button
                        class="underline ml-2 font-semibold"
                        v-if="canShowModal"
                        v-text="$lang.get('Read more')"
                        @click="onReadMore"
                    />
                </div>

                <div class="flex">
                    <button
                        type="button"
                        class="hover:bg-primary-hover transition duration-button-hover rounded-button"
                        @click="onClose"
                    >
                        <PhX class="size-5 text-white" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </Transition>
    </VerticalSlideTransition>
    <ModalTemplate
        :show="showModal"
        :close-button="true"
        :title="$page.props.announcement?.modal_title"
        :wrapTitle="true"
        @close="showModal = false"
        width="max-w-3xl w-full"
        padding="p-0"
    >
        <div class="rounded-modal overflow-hidden">
            <div
                class="px-6 py-8 relative max-h-[80dvh] min-w-fit overflow-y-auto flex flex-col gap-2"
            >
                <div
                    v-html="$page.props.announcement?.modal_text"
                    class="[&_li]:mt-1.5 space-y-8 [&_ul]:list-disc px-4"
                ></div>
            </div>
        </div>
    </ModalTemplate>
</template>

<script>
import { router } from '@inertiajs/vue3'

import ModalTemplate from '@/Components/Templates/ModalTemplate.vue'
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'
import { PhX, PhArrowRight } from '@phosphor-icons/vue'

export default {
    name: 'Announcement',

    components: {
        ModalTemplate,
        VerticalSlideTransition,
        PhX,
        PhArrowRight,
    },

    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            showModal: false,
            showAnnouncement: true,
        }
    },

    computed: {
        canShowModal() {
            return (
                this.$page.props.announcement?.modal_title ||
                this.$page.props.announcement?.modal_text
            )
        },
    },

    methods: {
        onReadMore() {
            if (!this.canShowModal) {
                return
            }
            this.showModal = true
        },

        onClose() {
            router.visit(route('announcement.markasread'), {
                preserveState: true,
                preserveScroll: true,
            })
        },
    },
}
</script>
